/**
 * Batched low lift test 5. auto popup signup modal timing
 * PRD: https:www.notion.so/faire/Batched-low-lift-tests-5e086078cc52486c815306fdae3076f6
 * Product Area: SEO
 */
export const NUMBER_UI_TEST_1_240528 = 'NUMBER_UI_TEST_1_240528';
